<div class="animated fadeIn">
  <div class="grid">
    <div class="col-12">
      <div class="card mb-0">
        <div class="card-body">
          <div>
            <div [class]="dashboardView ? '' : 'mt-4'">
              <p-table [value]="invoicesHeaders" [customSort]="true" responsiveLayout="stack" (sortFunction)="getPaginatedSortedInvoices($event)">
                <ng-template pTemplate="caption">
                  <div *ngIf="!dashboardView">
                    <div
                      class="mx-auto mb-4 w-8"
                      *ngIf="remainingTransactions && !remainingTransactions?.INVOICE?.isActiveLicense && !remainingTransactions?.isActiveLicense"
                    >
                      <app-license-limit-banner
                        [licenseLimitModule]="'Invoice Transactions'"
                        [licenseLimitRemaining]="remainingTransactions?.INVOICE?.remainingCount"
                        [licenseLimitUsed]="remainingTransactions?.INVOICE?.usedCount"
                      ></app-license-limit-banner>
                    </div>
                  </div>
                  <div class="grid" *ngIf="!dashboardView">
                    <div class="sm:col-6">
                      <button
                        pButton
                        icon="pi pi-plus"
                        label="Add"
                        [routerLink]="['/app/invoice/create-invoice']"
                        class="p-button-outlined mb-2 mr-2"
                      ></button>

                      <button
                        pButton
                        *ngIf="invoicesHeaders.length > 0"
                        icon="pi pi-file-excel"
                        [label]="exportingItems ? 'Exporting...' : 'Export'"
                        class="p-button-outlined mb-2 mr-2"
                        (click)="getInvoices()"
                        [disabled]="exportingItems"
                      ></button>
                      <button
                        pButton
                        *ngIf="invoicesHeaders.length > 0"
                        icon="pi pi-cog"
                        label="Customize"
                        class="p-button-outlined mb-2 mr-2"
                        (click)="openCustomizeInvoiceDialog()"
                      ></button>
                      <span style="position: relative">
                        <p-menu appendTo="body" #menu [model]="items" [popup]="true"></p-menu>

                        <button
                          pButton
                          type="button"
                          (click)="menu.toggle($event)"
                          icon="pi pi-filter"
                          label="Filter"
                          class="p-button-outlined mb-2 mr-2"
                        ></button>
                      </span>
                      <p-dialog header="Select date range" [(visible)]="calendarVisible">
                        <p-calendar
                          class="max-w-full"
                          selectionMode="range"
                          [(ngModel)]="dateRangeFilter"
                          [inline]="true"
                          [showWeek]="true"
                        ></p-calendar>
                        <div class="flex flex-row justify-content-between align-items-center">
                          <button
                            pButton
                            label="Cancel"
                            class="p-button-outlined mb-2"
                            (click)="dateRangeFilter = []; calendarVisible = false"
                          ></button>
                          <button pButton label="Apply" class="mr-2 mb-2" (click)="filterByDate()"></button>
                        </div>
                      </p-dialog>

                      <button
                        pButton
                        label="Clear"
                        class="p-button-outlined mb-2"
                        icon="pi pi-filter-slash"
                        (click)="clearSearch(); dateRangeFilter = []"
                        [disabled]="!searchText && !dateRangeFilter"
                      ></button>
                    </div>

                    <div class="sm:col-6 text-right">
                      <span class="p-input-icon-left mb-2">
                        <i class="pi pi-search"></i>
                        <input
                          pInputText
                          class="p-inputtext p-component p-element w-full"
                          #search
                          type="text"
                          placeholder="Search... "
                          [(ngModel)]="searchText"
                          (keyup.enter)="searchOnEnter(search.value)"
                        />
                      </span>

                      <button pButton class="p-button-outlined mb-2" icon="pi pi-search" (click)="getSearchResults()" *ngIf="searchText"></button>
                    </div>
                  </div>
                  <div class="" *ngIf="dashboardView">
                    <span class="overview-title font-medium"> RECENT INVOICES </span>
                  </div>
                </ng-template>

                <ng-template pTemplate="header" responsiveLayout="stack">
                  <tr>
                    <th *ngFor="let column of tableColumns" [pSortableColumn]="column.sortField">
                      {{ column?.displayName }}
                      <p-sortIcon [field]="column.sortField"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-invoiceHeader>
                  <tr class="p-selectable-row table-row-clickable">
                    <td *ngFor="let column of tableColumns">
                      <span class="p-column-title">{{ column?.displayName }}</span>
                      {{
                        column.fieldName === 'transactionTotalAmount' || column.fieldName === 'transactionBalance'
                          ? (utilService.getValue(invoiceHeader, column.fieldName)
                            | currency: (invoiceHeader.currency?.symbol ? invoiceHeader.currency.symbol : invoiceHeader.currency?.code))
                          : column.fieldName === 'transactionDueDate'
                            ? invoiceHeader.transactionStatus === 'PAID'
                              ? (invoiceHeader.transactionDueDate | date)
                              : displayDueDate(invoiceHeader.transactionDueDate)
                            : utilService.getValue(invoiceHeader, column.fieldName) || '--'
                      }}
                    </td>

                    <td *ngIf="!dashboardView">
                      <div>
                        <p-splitButton
                          appendTo="body"
                          label="Details"
                          icon="pi pi-folder-open"
                          [model]="invoiceHeader?.menuItems"
                          (onClick)="router.navigate(['/app/invoice/invoice-details/' + invoiceHeader?._id])"
                        ></p-splitButton>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>

              <div class="grid m-0">
                <div class="col-sm">
                  <p-paginator
                    #paginator
                    [rows]="defaultPagination.pageSize"
                    [totalRecords]="defaultPagination.totalCount"
                    (onPageChange)="paginate($event)"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  ></p-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-dialog
        header="Add a payment"
        [(visible)]="paymentDialog"
        [breakpoints]="{ '960px': '75vw' }"
        [style]="{ width: '50vw' }"
        [draggable]="false"
        [resizable]="false"
      >
        <div class="flex flex-wrap gap-3 p-fluid">
          <form [formGroup]="addPaymentForm" class="w-full">
            <div class="flex align-items-start field-space-btwn">
              <div class="col-2">
                <label for="paidInCurrency">Currency</label>
                <!-- <p-dropdown
                                    formControlName="currency"
                                    [options]="formattedCurrencyList"
                                    optionLabel="formattedLabel"
                                    optionValue="currencySymbolOrCode"
                                    [filter]="true"
                                    filterBy="country"
                                    [showClear]="true"
                                >
                                </p-dropdown> -->
                <input formControlName="paidInCurrency" id="paidInCurrency" type="text" pInputText />
              </div>
              <div class="col-10">
                <label for="paidInCurrencyAmount">Amount</label>
                <p-inputNumber inputId="paidInCurrencyAmount" formControlName="paidInCurrencyAmount"> </p-inputNumber>
              </div>
            </div>

            <div class="flex-auto">
              <label for="paymentTerm">Paid with</label>
              <p-dropdown
                inputId="paymentTerm"
                formControlName="paymentTerm"
                placeholder="Select payment term"
                [options]="organizationPaymentTerms"
              ></p-dropdown>
            </div>
          </form>
        </div>
        <div class="mt-4 text-right">
          <button
            label="Cancel"
            pButton
            type="button"
            icon="pi pi-times"
            iconPos="left"
            (click)="paymentDialog = false"
            class="p-button-danger mr-2"
          ></button>

          <button
            label="Save"
            pButton
            type="button"
            icon="pi pi-plus"
            iconPos="left"
            (click)="addPayment()"
            [disabled]="!addPaymentForm.valid"
          ></button>
        </div>
      </p-dialog>
      <p-toast></p-toast>
    </div>
  </div>
</div>

<p-dialog header="Invoice History" [modal]="true" [(visible)]="invoiceHistoryDialog" [style]="{ width: '50rem' }">
  <div class="grid h-full">
    <div class="col-12">
      <div class="card widget-timeline h-full">
        <div class="timeline-content">
          <div class="flex justify-content-center p-4" *ngIf="invoiceHistory?.length <= 0">
            <p>There are no history on this invoice.</p>
          </div>

          <p-timeline *ngIf="invoiceHistory?.length > 0" [value]="invoiceHistory" styleClass="customized-timeline  pt-4">
            <ng-template pTemplate="marker" let-activity>
              <span class="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1 bg-blue-500">
                <i class="pi pi-history"></i>
              </span>
            </ng-template>
            <ng-template pTemplate="content" let-activity>
              <div class="flex align-items-center justify-content-between">
                <div [innerHTML]="activity?.currentStatus"></div>
              </div>
              <span>{{ activity?.createdAt | date: 'medium' }}</span>
            </ng-template>
          </p-timeline>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
